"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Svg = void 0;
var rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
Object.defineProperty(exports, "Svg", { enumerable: true, get: function () { return rpdf_renderer_1.Svg; } });
//# sourceMappingURL=svg.js.map